const LeadsTableType = {
  LEADS: 'LEADS',
  IS_LEADS: 'IS_LEADS',
};

export {
  LeadsTableType,
};
